export default __webpack_public_path__ + "static/media/ico-cafeteria.10cdc8f1.svg";